import React, { FC, useEffect, useMemo, useState } from "react";

export const PetQuote: FC = () => {
    const quotes = useMemo(
        () => [
            {
                quote: "I believe cats to be spirits come to earth. A cat, I am sure, could walk on a cloud without coming through.",
                from: "Jules Verne",
            },
            {
                quote: "Animals are such agreeable friends – they ask no questions; they pass no criticisms.",
                from: "George Eliot",
            },
            {
                quote: "Time spent with cats is never wasted.",
                from: "Sigmund Freud",
            },
            {
                quote: "He who is cruel to animals becomes hard also in his dealings with men. We can judge the heart of a man by his treatment of animals.",
                from: "Immanuel Kant",
            },
            {
                quote: "Pets are humanizing. They remind us we have an obligation and responsibility to preserve and nurture and care for all life.",
                from: "James Cromwell",
            },
            {
                quote: "A bird does not sing because it has an answer.  It sings because it has a song.",
                from: "Howard Clemmons",
            },
            {
                quote: "Until one has loved an animal, a part of one’s soul remains unawakened.",
                from: "Anatole France",
            },
        ],
        []
    );

    const [quote, setQuote] = useState(quotes[0]);

    useEffect(() => {
        setQuote(quotes[Math.floor(Math.random() * quotes.length)]);
    }, [quotes]);

    return (
        <blockquote>
            {quote.quote}
            <footer>{quote.from}</footer>
        </blockquote>
    );
};
